export default __webpack_public_path__ + "4a002410ca6fbf546103730ebc508210.png";